<div class="flex items-center gap-2 h-8">
  <mat-label [class]="beforeLabelClass">{{ beforeLabel }}</mat-label>
  <mat-slide-toggle
          [formControl]="control"
          color="primary"
  ></mat-slide-toggle>
  <mat-label>{{ afterLabel }}</mat-label>
</div>
